export default __webpack_public_path__ + "static/media/registerSchool.bc4d2005.png";